export default __webpack_public_path__ + "static/media/Handshake.add7477c.svg";